import {useParams} from "react-router-dom";
import {ViewDocumentPanel} from "document/component/container";
import {CaptacionService} from "abastecemento/service";

const ViewCaptacionDocumentPanel = () => {
    const {idCaptacion} = useParams();

    const handleSetFeaturedImage = documentId => {
        return CaptacionService.updateWithPatch({
            id: idCaptacion,
            featured_image: documentId,
        });
    };

    const handleSetFeaturedDocument = documentId => {
        return CaptacionService.updateWithPatch({
            id: idCaptacion,
            featured_document: documentId,
        });
    };

    return (
        <ViewDocumentPanel
            onSetFeaturedImage={handleSetFeaturedImage}
            onSetFeaturedDocument={handleSetFeaturedDocument}
        />
    );
};

export default ViewCaptacionDocumentPanel;
